<template>
  <span id="app" class="dtable w100">
    <router-view class=""/>
        <KeyboardCodeHandler></KeyboardCodeHandler>
        <HealthChecker/>
        <Modal/>
        <Alert/>


  </span>
</template>


<script>
  import i18n from '@/i18n';
  import KeyboardCodeHandler from '@/components/KeyboardCodeHandler.vue';
  import HealthChecker from '@/components/HealthChecker.vue';
  import Modal from '@/components/Modal.vue';
  import Alert from '@/components/Alert.vue';
  import moment from 'moment';

  export default {
    data() {
      return {
        lang: "en",
      };
    },
    watch: {
      lang: function (newLang, oldLang) {
        i18n.locale = newLang;
      }
    },
    mounted() {
      const modul = this;
      modul.extendValidator();
    },
    methods: {
      extendValidator() {
        const modul = this;

        this.$validator.extend(
          'numberprice', { // Ez nem más, mint a decimal, csak 3 tizedesre vágva
            getMessage: field => field + ' needs to be > zero.',
            validate: (value) => {
                console.log("numberprice")
              // value must be > zero
              const countDecimals = function (num) {
                if (Math.floor(num.valueOf()) === num.valueOf()) return 0;
                return num.toString().split(".")[1].length || 0;
              };
              try {
                  const arrVal=value.split(".");
                if (
                    String(Number(value)) ===arrVal[0] && arrVal[1] && Number(arrVal[1])===0 // 123.000
                    || value.toString().split(".")[0] === "0" // 123.
                    || (String(Number(value)) === String(value)  // it same
                    || String(Number(value)) === String(value).replace(".", "")) && countDecimals(Math.abs(Number(value))) <= 3 // 0.123
                ) {
                  return true;
                } else {
                  return false;
                }
              } catch (e) {
                console.log("false-numberprice-ex");
                return false;
              }
            }
          });
        this.$validator.extend(
          'isodate', { // YYYY-MM-DD
            getMessage: field => field + ' needs to be > zero.',
            validate: (value) => {
              try {
                let dateAndTime = value.split(' ');
                let arr = [];
                let format = 'YYYY-MM-DD';
                if(value.search("/")>=0){
                  format = 'YYYY/MM/DD';
                }
                if (format.indexOf('-') > -1) {
                  arr = dateAndTime[0].split('-')
                } else {
                  arr = dateAndTime[0].split('/')
                }
                let year = 0;
                let month = 0;
                let day = 0;
                if (format.indexOf('DD/MM/YYYY') === 0 || format.indexOf('DD-MM-YYYY') === 0) {
                  year = arr[2];
                  month = arr[1];
                  day = arr[0];
                } else if (format.indexOf('YYYY/MM/DD') === 0 || format.indexOf('YYYY-MM-DD') === 0) {
                  year = arr[0];
                  month = arr[1];
                  day = arr[2];
                  if (year.length === 4 && month.length === 2 && day.length === 2 && parseInt(month) > 0 && parseInt(month) < 13 && parseInt(day) > 0 && parseInt(day) < 32) {
                    if (moment(value).format('YYYY-MM-DD') === value) {
                      return  true;
                    } else {
                      return false;
                    }
                  } else {
                    return false; // we take back an empty string at wrong date
                  }
                }
              } catch (e) {
                console.log("false-isodate-ex")
                return false;
              }
            }
          });
      },
    },
    components: {
      KeyboardCodeHandler,
      HealthChecker,
      Modal,
      Alert,
    }
  }
</script>

<style lang="css">

  @import 'assets/vendor/sufee-admin-dashboard/assets/css/normalize.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/bootstrap.min.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/font-awesome.min.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/themify-icons.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/flag-icon.min.css';
  /*  // Not loading, broken maybe?
    // @import 'assets/vendor/sufee-admin-dashboard/assets/css/cs-skin-elastic.css';*/
  @import 'assets/vendor/sufee-admin-dashboard/assets/scss/style.css';
  @import 'assets/vendor/sufee-admin-dashboard/assets/css/fonts.css';
  @import 'assets/css/untitled-font-2.css';

  .white-space-pre {
    white-space: pre;
  }

  .valigntop{
    vertical-align:top;
  }
  .rowcolorred{
    color: red;
  }
  .rowred{
    background-color: #dc3545;
  }
  .rowgreen{
    background-color: #28a745;
  }
  .rowyellow{
    background-color: #ffc107;
  }
  .rowblue{
    background-color: #007bff;
  }
  .rowstwhite{ background-color: var(--white);}
  .rowstgreen{ background-color: var(--green);}
  .rowstgray{ background-color: var(--gray);}

  /* //
   // #app {
   //   font-family: 'Avenir', Helvetica, Arial, sans-serif;
   //   -webkit-font-smoothing: antialiased;
   //   -moz-osx-font-smoothing: grayscale;
   //   text-align: center;
   //   color: #2c3e50;
   // }
   // #nav {
   //   padding: 30px;
   //   a {
   //     font-weight: bold;
   //     color: #2c3e50;
   //     &.router-link-exact-active {
   //       color: #42b983;
   //     }
   //   }
   // }*/

  .btn.btn-link {
    border: 1px solid #007bff;
  }

  .checkboxMiddle {
    width: 18px;
    height: 18px;
  }

  .checkboxBig {
    width: 24px;
    height: 24px;
  }

  .w100 {
    width: 100%;
  }

  .w100i {
    width: 100% !important;
  }

  .w0 {
    width: 0%;
  }

  .w1 {
    width: 1%;
  }

  .w50 {
    width: 50%;
  }

  .w49 {
    width: 49%;
  }

  .dtable {
    display: table;
  }

  .dtablerow {
    display: table-row;
  }

  .dtablecell {
    display: table-cell;
  }

  .pointer {
    display: table-cell;
  }

  body .navbar .navbar-nav li > a {
    padding: 0;
    font-size: 13px;
    line-height: 24px;
  }

  body .navbar .menu-title {
    padding: 0;
  }

  .infoblock {
    background-color: #f8f8e4;
    padding: 10px 0;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .input-group-addon-danger {
    color: #fff;
    background-color: #dc3545;
    border-color: #dc3545;
  }

  .input-group-addon-success {
    color: #fff;
    background-color: #28a745;
    border-color: #28a745;
  }

  .disabledFunction {
    position: relative;
    top: 0;
    left: 0;
  }

  .disabledFunction:after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-color: rgba(255, 255, 255, 0.7);
  }

  /* Form errors */
  body [aria-invalid="true"] {
    border-color: #dc3545;
  }

  body .font-size-small {
    font-size: small
  }

  body .font-size-smaller {
    font-size: smaller
  }

  body .dataTableContent {
    overflow: auto;
  }

  /*
  fContainer -- konténer
      fColumn -- olyan class ami szükséges az összes konténer, és a layout-ok közé a működéshez
          fHead -- layout header, NEM nyúlik az oldal magasságához
          fContent -- layout content, IGEN, nyúlik az oldal magasságához
          fFix -- layout header, footer, és bármi amit fix-re akarunk, tehát NEM nyúlik az oldal magasságához
  fFootHck -- Footer hack, ami ahhoz kell, hogy a nagyobbra nyitásnál is úgy nézzen ki, mint ha növekedne az ablak.
          Csak teljes képernyős módra jó, és csak akkro ha card elem alatti footerről van szó.
  fCard -- A korábbi fFootHck elem card-ja, ami alá fehéret teszünk, mintha az adott card nyúlna
  */

  /* alap layoutok */

  @media (max-width: 575.99px) {
    body {
      font-size: 14px;
    }

    body .fContainer {
      position: absolute;
      /*height: 100%;*/
      width: 95%;

    }

    body .fContainer.mw90 {
      position: absolute;
      /*height: 100%;*/
      width: 90%;

    }

    body .fContainer {
      /*position: absolute;*/
      /*height: 100%;*/
      /*width: 100%;*/
      display: flex;
      flex-direction: column;
    }

    body .fContainer .fColumn {
      flex-direction: column;
      display: flex;
      flex-shrink: 1;
    }

    body .fContainer .fHead {
      flex-shrink: 0;
    }

    body .fContainer .fContent {
      overflow-y: auto;
      overflow-x: auto;
    }

    body .fContainer .fFix {
      flex-shrink: 0;
    }

    /* / alap layoutok */
    /* fFootHck layoutok */
    body .fContainer .fFootHck {
      flex-shrink: 0;
      position: relative;
      top: 0;
      left: 0;
    }

    body .fContainer .fFootHck > div {
      position: fixed;
      bottom: 0;
      width: 100%;
      left: 0;
      padding: 0 20px;
    }

    body .fContainer .fFootHck:after {
      content: "";
      display: block;
      height: 72px;
      /*border: red dashed 1px;*/
    }

    body .fContainer .fFootHck .fFootHckExt > div {
      border: 1px solid rgba(0, 0, 0, .125);
    }

    body .fContainer .fFootHckExt:after {
      content: "";
      display: block;
      height: 15px;
      background-color: #f1f2f7;
      /*border: red dashed 1px;*/
    }

    /* Ez a scroller hez kötődő paddingokat kezeli, hogy a scroller illeszkedjen a külső div-hez */
    body .fContainer .pt-15 {
      padding-top: 15px;
    }

    body .fContainer .pb-15 {
      padding-bottom: 15px;
    }

    body .fContainer .pt-0 {
      padding-top: 0;
    }

    body .fContainer .pb-0 {
      padding-bottom: 0;
    }

    @media (max-width: 1368px) {
      body .fContainer .fFootHckExt:after {
        height: 15px;
      }

      body .fContainer .fFootHck > div {
        position: fixed;
        bottom: 0;
        width: 100%;
        left: 0;
        padding: 0 15px;
      }
    }
    /* Ez folyatja a fehér hátteret lefelé */
    /*body .fContainer .fCard{*/
    /*!*border-bottom:none;*!*/
    /*border-bottom-width:0;*/
    /*border-right:1px solid rgba(0,0,0,.125);*/
    /*border-left:1px solid rgba(0,0,0,.125);*/
    /*}*/
    /*body .fContainer .fCard:after {*/
    /*content: "";*/
    /*width: 100%;*/
    /*height: 2000px;*/
    /*position: absolute;*/
    /*top: 0;*/
    /*left: 0;*/
    /*!*border: 1px solid red;*!*/
    /*background-color: white;*/
    /*z-index: -1;*/
    /*}*/
    /* / Ez folyatja a fehér hátteret lefelé */
    /* / fFootHck layoutok */
    /* Ez a scroller szélesítés */
    .dataTables_scrollBody::-webkit-scrollbar,
    body .fContainer .fContent::-webkit-scrollbar {
      width: 30px;
      height: 30px;
    }

    .dataTables_scrollBody::-webkit-scrollbar-track,
    body .fContainer .fContent::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      background-color: #eee;
    }

    .dataTables_scrollBody::-webkit-scrollbar-thumb,
    body .fContainer .fContent::-webkit-scrollbar-thumb {
      background-color: #ccc;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
    }

    /* / Ez a scroller szélesítés */

  }

  .colors {
    --blue: #007bff;
    --indigo: #6610f2;
    --purple: #6f42c1;
    --pink: #e83e8c;
    --red: #dc3545;
    --orange: #fd7e14;
    --yellow: #ffc107;
    --green: #28a745;
    --teal: #20c997;
    --cyan: #17a2b8;
    --white: #fff;
    --gray: #868e96;
    --gray-dark: #343a40;
    --primary: #007bff;
    --secondary: #868e96;
    --success: #28a745;
    --info: #17a2b8;
    --warning: #ffc107;
    --danger: #dc3545;
    --light: #f8f9fa;
    --dark: #343a40;
  }

  .TouchKeyboardBp .keyboard {
    width: 100%;
    margin: 0;
  }

  .TouchKeyboardBp .keyboard .line {
    display: flex;
    justify-content: space-around;
  }

  .TouchKeyboardBp .keyboard .line:not(:last-child) {
    margin-bottom: 0.5em;
  }

  .TouchKeyboardBp .keyboard .key {
    flex: 40;
    /*height: 2.2em;*/
    height: 2.7em;
    line-height: 2.2em;
    overflow: hidden;
    vertical-align: middle;
    border: 1px solid #ccc;
    color: #333;
    background-color: #fff;
    /*box-shadow: 0px 2px 2px rgba(0, 0, 0, .6);*/
    border-radius: 0.35em;
    font-size: 1.25em;
    text-align: center;
    white-space: nowrap;
    user-select: none;
    cursor: pointer;
  }

  .TouchKeyboardBp .keyboard .key:not(:last-child) {
    margin-right: 0.5em;
  }

  .TouchKeyboardBp .keyboard .key.backspace {
    /*background-image: url("./icons/backspace.svg");*/
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 35%;
  }

  .TouchKeyboardBp .keyboard .key.half {
    flex: 20;
  }

  .TouchKeyboardBp .keyboard .key.control {
    color: #fff;
    background-color: #7d7d7d;
    border-color: #656565;
  }

  .TouchKeyboardBp .keyboard .key.control:hover {
    color: #fff;
    background-color: #8d8d8d;
    border-color: #656565;
  }

  .TouchKeyboardBp .keyboard .key.featured {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }

  .TouchKeyboardBp .keyboard .key.featured:hover {
    color: #fff;
    background-color: #438ac7;
    border-color: #2e6da4;
  }

  .TouchKeyboardBp .keyboard .key.dbplus.featured {
    color: #fff;
    background-color: #dc3545;
    border-color: #bc1525;
  }

  .TouchKeyboardBp .keyboard .key.dbplus.featured:hover {
    color: #fff;
    background-color: #ec4555;
    border-color: #cc2535;
  }

  .TouchKeyboardBp .keyboard .key:hover {
    color: #333;
    background-color: #d6d6d6;
    border-color: #adadad;
  }

  .TouchKeyboardBp .keyboard .key:active {
    transform: scale(0.98);
    color: #333;
    background-color: #d4d4d4;
    border-color: #8c8c8c;
  }

  .TouchKeyboardBp .keyboard .key.activated {
    color: #fff;
    background-color: #5bc0de;
    border-color: #46b8da;
  }

  .TouchKeyboardBp .keyboard .key {
    color: #aaa;
    background: #eff0f2;
    border-radius: 0;
    border-top: 1px solid #ddd;

    /*box-shadow: inset 0 0 25px #e8e8e8, 0 1px 0 #c3c3c3, 0 2px 0 #c9c9c9, 0 2px 3px #333;*/
    /*text-shadow: 0px 1px 0px #f5f5f5;*/
  }

  .TouchKeyboardBp .keyboard .key.control {
    /*box-shadow: 0 1px 0 #c3c3c3, 0 2px 0 #c9c9c9, 0 2px 3px #333;*/
    /*text-shadow: 0px 1px 0px #777;*/
  }

  .TouchKeyboardBp .keyboard .key:hover {
    color: #aaa;
    /*background-color: inherit;*/
    border-color: inherit;
  }

  .TouchKeyboardBp .keyboard .key:active {
    color: #888;
    background: #ebeced;
    transform: translateY(3px);
    /*box-shadow: inset 0 0 25px #ddd, 0 0 3px #333;*/
    border-top: 1px solid #eee;
  }

  .TouchKeyboardBp .keyboard .placeholder {
    flex: 19;
    height: 2.2em;
    line-height: 2.2em;
  }

  .TouchKeyboardBp .keyboard .placeholder:not(:last-child) {
    margin-right: 0.5em;
  }

  .TouchKeyboardBp .keyboard:before, .TouchKeyboardBp .keyboard:after {
    content: "";
    display: table;
  }

  .TouchKeyboardBp .keyboard:after {
    clear: both;
  }

  .TouchKeyboardBp .keyboard .key:not(.control):not(.accept) {
    border: 1px solid #878787;
    color: #878787;
    background: linear-gradient(180deg, rgba(247, 247, 247, 1) 0%, rgba(234, 234, 234, 1) 50%, rgba(221, 221, 221, 1) 100%);
  }

  .TouchKeyboardBp .keyboard .key:not(.control):not(.accept):hover {
    border: 1px solid #878787;
    color: #878787;
    background: linear-gradient(0deg, rgba(247, 247, 247, 1) 0%, rgba(234, 234, 234, 1) 50%, rgba(221, 221, 221, 1) 100%);
  }

  .TouchKeyboardBp .keyboard .key.featured.accept {
    /*background-color: #28a745;*/
    border-color: #28a745;
    line-height: 2.8em;
    background: #28a745;
  }

  .TouchKeyboardBp .keyboard .key.featured.accept:hover {
    /*background-color: #28a745;*/
    border-color: #38b755;
    line-height: 2.8em;
    background: #38b755;
  }

  .TouchKeyboardBp .keyboard .key.accept:before {
    /*content: "O";*/
    content: "\f00c";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding: 5px 0 0 0;
  }

  .TouchKeyboardBp .keyboard .key.featured.next {
    /*background-color: #28a745;*/
    border-color: #28a745;
    line-height: 2.8em;
    background: #28a745;
  }

  .TouchKeyboardBp .keyboard .key.featured.next {
    /*background-color: #28a745;*/
    border-color: #38b755;
    line-height: 2.8em;
    background: #38b755;
  }

  .TouchKeyboardBp .keyboard .key.next:before {
    /*content: "O";*/
    content: "\f00c \f101";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding: 5px 0 0 0;
  }

  /*.TouchKeyboardBp .keyboard .key.featured.cursorleft{*/
  /*border-color: #38b755;*/
  /*line-height: 2.8em;*/
  /*background: #38b755;*/
  /*}*/
  .TouchKeyboardBp .keyboard .key.cursorleft:before {
    content: "\f060";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    text-rendering: auto;
    padding: 5px 0 0 0;
    /*font-size: inherit;*/
  }

  /*.TouchKeyboardBp .keyboard .key.featured.cursorRight{*/
  /*border-color: #38b755;*/
  /*line-height: 2.8em;*/
  /*background: #38b755;*/
  /*}*/
  .TouchKeyboardBp .keyboard .key.cursorRight:before {
    content: "\f061";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    text-rendering: auto;
    padding: 5px 0 0 0;
    /*font-size: inherit;*/
  }

  .TouchKeyboardBp .keyboard .key.backspace {
    /*background-image: url("./icons/backspace.svg");*/
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 35%;
  }

  .TouchKeyboardBp .keyboard .key.backspace:before {
    /*content: "O";*/
    content: "\f060";
    display: block;
    font: normal normal normal 33px/1 FontAwesome;
    font-size: 33px;
    /*font-size: inherit;*/
    text-rendering: auto;
    padding: 5px 0 0 0;
  }

  .openKeyboard .vue-touch-keyboard-holder-inner.layout-n, .openKeyboard .vue-touch-keyboard-holder-inner.layout-nplus, .openKeyboard .vue-touch-keyboard-holder-inner.layout-ndbplus, .openKeyboard .vue-touch-keyboard-holder-inner.layout-nn {
    max-width: 600px;
    margin: 0 auto;
    display: block;
  }

  .vue-touch-keyboard-holder.openKeyboard {
    padding: 130px 100px 0 100px;
  }

  .vue-touch-keyboard-holder.openKeyboard input {
    font-size: 2rem;
  }

  .input-group .custom-file.w100, .input-group .custom-select.w100, .input-group .form-control.w100 {
    width: 100%;
  }

  @media (max-width: 800px) {
    .vue-touch-keyboard-holder.openKeyboard {
      padding: 65px 50px 0 50px;
    }
  }

  /*
  .TouchKeyboardBp .keyboard .key{
      font-size: 1.5em;
      line-height: 1.9em;
      box-shadow: none ;
      border-radius: 0 ;

  }
  .TouchKeyboardBp .keyboard .key:not(.control):not(.accept){
      border: 1px solid #878787;
      color: #878787;
      background: linear-gradient(180deg, rgba(247,247,247,1) 0%, rgba(234,234,234,1) 50%, rgba(221,221,221,1) 100%);
  }
  .TouchKeyboardBp .keyboard .key.featured.accept{
      /*background-color: #28a745;* /
      border-color: #28a745;
      line-height: 2.8em;
      background: #28a745;
  }
  .TouchKeyboardBp .keyboard .placeholder{
      flex:19
  }
  .TouchKeyboardBp-holder.openKeyboard h5{
      font-size: 1.5em;
  }


  .accept:before {
      / *content: "O";* /
      content: "\f00c";
      display: block;
      /*background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgaGVpZ2h0PSI0O…4xNyAyLjgzIDIuODMtNy4xNyA3LjE3IDcuMTcgNy4xN3oiIGZpbGw9IndoaXRlIi8+PC9zdmc+);* /
      /*background-repeat: no-repeat;* /
      /*background-position: center;* /
      /*font-size: 0;* /
      font: normal normal normal 33px/1 FontAwesome;
      font-size: 33px;
      /*font-size: inherit;* /
      text-rendering: auto;
      padding :5px 0 0 0;
  }
  .extrafield{
      display: block;
      width: 100%;
      border: 0;
      padding: 0;
  }
  body .TouchKeyboardBp .keyboard .key{
      /*height: 2.7em;* /
  }
  */


  /* Ez majd a hamburgermenühöz css, de kell minden cucchoz a beléhez is.
  aside.left-panel{
    display: block;
    height: auto;
    min-height: inherit;
    padding: 0 15px;
    width: 100%;
  }
  .right-panel {
    display: block;
  }
  */
</style>
